import Badge from 'Root/App/Badge'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'
import Link from 'Root/Component/Link'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'

import styles from './index.module.css'

const Item = ({
  title,
  description,
  link,
  icon,
  items,
  setCurrent,
  callback,
  index,
  searchParams = '',
}) => {
  if (!isNil(items) && !isEmpty(items)) {
    return (
      <div>
        <button
          className={styles.item}
          onClick={() => setCurrent(items, index)}
        >
          <img className={styles.img} src={icon.src} alt={title} />
          <div>
            <Title size="XS">{title}</Title>
            <Paragraph size="S">{description}</Paragraph>
          </div>
        </button>
      </div>
    )
  }

  const getCreateElementPageLink = () => {
    if (searchParams.length === 0) return link

    return link.includes('?')
      ? `${link}&${searchParams}`
      : `${link}?${searchParams}`
  }

  return (
    <Link
      className={styles.item}
      onClick={callback}
      shallow
      to={getCreateElementPageLink()}
      replace
    >
      <img className={styles.img} src={icon.src} alt={title} />
      <div>
        <Title size="XS" className="flex gap-2">
          {title}
          {icon.src.includes('free_text') ||
          icon.src.includes('content_audio') ? (
            <Badge schema="ACCENT">Beta</Badge>
          ) : null}
        </Title>
        <Paragraph size="S">{description}</Paragraph>
      </div>
    </Link>
  )
}

export default Item
